<template>
  <div class="rankListWrap">
    <div class="myListWrap">
      <div :class="`rankNum ${isNight ? 'rankNum_dark' : ''}`" v-if="rankPosition > 3 || !rankPosition">
        {{`${(rankPosition > 99 || rankPosition === 0) ? '-' : rankPosition}`}}
      </div>
      <div class="rankIconWrap" v-else  >
        <LazyImage :src="getRankIcon(event,rankPosition)" class="rankIcon" type="headerPic" />
      </div>
      <div :class="`rankMyInfo ${isNight ? 'rankMyInfo_dark' : ''}`">
        <LazyImage :src="avatarUrl" class="rankHeadIcon" type="headerPic" />
        <div :class="`rankName ${isNight ? 'rankName_dark' : ''}`">Me</div>
        <div :class="`rankScore ${isNight ? 'rankScore_dark' : ''}`">
          {{inviteTotalScore ? (symbol + inviteTotalScore) : (symbol + 0) }}
        </div>
      </div>
    </div>
    <div :class="`rankLine ${isNight ? 'rankLine_dark' : ''}`" ></div>
    <van-list
      :class="`${ChangeListHeight} ? listWrap : ''`"
      v-model="loading"
      :finished="finished"
      @load="onLoad"
    >
      <div v-for="item in listData" :key="item.sort" class="listContent">
        <div class="listItem">
          <div :class="`rankNum ${isNight ? 'rankNum_dark' : ''}`" v-if="item.sort > 3">
            {{ item.sort }}
          </div>
          <div class="rankIconWrap" v-else>
            <LazyImage :src="getRankIcon(event,item.sort)" class="rankIcon" type="headerPic" />
          </div>
          <div :class="`rankInfo ${isNight ? 'rankInfo_dark' : ''}`">
            <LazyImage
              :src="item.image"
              class="rankHeadIcon"
              type="headerPic"
            />
            <div :class="`rankName ${isNight ? 'rankName_dark' : ''}`">
              {{ item.name }}
            </div>
            <div :class="`rankScore ${isNight ? 'rankScore_dark' : ''}`">
                {{ symbol + item.score / 100}}
            </div>
          </div>
        </div>
      </div>
      <slot name="loading" v-if="loading">
        <compLoading />
      </slot>
      <div :class="`rankListFooter ${isNight ? 'rankListFooter_dark' : ''}`" v-if="listData.length >= 10">
        <div class="footerText">{{ $t("inviteDetail.rankingUpadted") }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import compLoading from "@src/components/loading";
import rank1 from "../images/rank-first.webp";
import rank2 from "../images/rank-second.webp";
import rank3 from "../images/rank-third.webp";

export default {
  components: {
    compLoading,
  },
  props: ["listData", "symbol","avatarUrl","inviteTotalScore","rankPosition", "loadings", "end", "isNight", "ChangeListHeight"],
  data() {
    return {
      loading: this.loadings,
      finished: this.end,
      rank1,
      rank2,
      rank3,
      event:"",
      inviteRank:0,
      myList: {
        image:
          "https://storeimg.heytapimg.com/uploadFiles/admin_appstore/202101/05/1071b6de5a89eef88bf115eb4f63040c.jpg",
        operateTime: "2021-08-24 21:30",
        name: "Jackson yj",
        score: 71,
        sort: 999,
      },
    };
  },
  beforeUpdate() {
    //解决loading一直出现问题
    this.finished = this.end;
    this.loading = this.loadings;
  },
  methods: {
    getRankIcon(e,sort) {
      if (sort == 1) {
        return rank1
      } else if (sort == 2) {
        return rank2
      }  else {
        return rank3
      }
    },
    onLoad() {
      console.log("onLoad");
      this.$emit("loadMore");
    },
    exposeRole(item) {
      this.$emit("expose", item);
    },
  },
};
</script>

<style scoped lang="stylus">
.rankListWrap {
  width:100%;  
}
.headIconWrap {
  display: flex;
  flex-direction: row;
  padding: 0 0.79rem;
}
.myListWrap {
  display: flex;
  width: 9.84rem;
  flex-direction: row;
  height: 1.59rem;
  margin: 0.48rem 0;
}
.rankLine {
  height: 0.01rem;
  background-color: rgba(0, 0, 0, 0.12);
  width: 8.888rem;
  margin: 0 0.48rem;
}
.rankLine_dark {
  background-color: rgba(255, 255, 255, 0.2);
}
.awardIconWrap {
  flex: 1;
  display: flex;
  justify-content: center;
}
.imgWrap {
  position: relative;
  width: 2.16rem;
  height: 2.52rem;
}
.bg {
  width: 2.16rem;
  height: 2.52rem;
}
.awardNum {
  position: absolute;
  width: 0.72rem;
  height: 0.72rem;
  left: 0.74rem;
  top: 2.06rem;
}
.rankIconWrap{
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.rankIcon{
  width: 0.72rem;
  height: 0.72rem;
  margin: 0 5px 0 11px;
}
.infoWrap {
  margin-top: 0.33rem;
  margin-bottom: 0.6rem;
  display: flex;
  flex-direction: row;
  padding: 0 0.24rem;
}
.infoItemWrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.infoItemWrap .awardScore {
  height: 0.78rem;
  line-height: 0.78rem;
  font-size: 0.54rem;
  font-family: "OPPOSans 2.14 NoVF";
  font-weight: 500;
  /* margin-top: 0.03rem; */
}
.listWrap {
  height: 12.31rem;
}
.awardUserName {
  font-size: 0.42rem;
  font-family: "OPPOSans 2.14 NoVF";
  line-height: 0.46rem;
  color: rgba(0, 0, 0, 0.55);
  width: 2.58rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 0.6rem;
  line-height: 0.6rem;
}
.awardUserName_dark {
  color: rgba(255, 255, 255, 0.55);
}
.listItem {
  display: flex;
  width: 9.84rem;
  flex-direction: row;
  height: 1.59rem;
  margin-bottom: 0.3rem;
}
.listContent:first-child {
  margin-top: 0.48rem;
}
.rankNum {
  width: 0.54rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.24rem 0 0.42rem;
  font-size: 0.42rem;
  font-family: "OPPOSans 2.14 NoVF";
  color: rgba(0, 0, 0, 0.55);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rankNum_dark {
  color: rgba(255, 255, 255, 0.55);
}
.rankInfo {
  background: rgba(0, 0, 0, 0.04);;
  border-radius: 1.11rem;
  padding: 0.12rem 0.48rem 0.12rem 0.12rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 7.56rem;
}
.rankMyInfo {
  background: rgba(253, 131, 38, 0.1);
  border-radius: 1.11rem;
  padding: 0.12rem 0.48rem 0.12rem 0.12rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 7.56rem;
}
.rankMyInfo_dark {
  background: rgba(255, 145, 61, 0.25);
}
.rankInfo_dark {
  background: rgba(255, 255, 255, 0.1);;
}
.rankHeadIcon {
  width: 1.35rem;
  height: 1.35rem;
  margin-right: 0.36rem;
  border-radius: 50%;
}
.rankName {
  width: 3.45rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "OPPOSans 2.14 NoVF";
  font-weight: 500;
  font-size: 0.42rem;
  color: rgba(0, 0, 0, 0.55);
  text-align: left;
}
.rankName_dark {
  color: rgba(255, 255, 255, 0.55);
}
.rankScore {
  flex: 1;
  text-align: right;
  color: rgba(0, 0, 0, 0.55);
  font-family: "OPPOSans 2.14 NoVF";
  font-size: 0.42rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rankScore_dark {
  color: rgba(255, 255, 255, 0.55);
}
.rankListFooter {
  padding-top: 0.57rem;
  padding-bottom: 1.23rem;
  margin: 0 0.48rem ;
  color: rgba(0, 0, 0, 0.3);
  font-size: 0.36rem;
  text-align: center;
}
.footerText{
    height:0.51rem;
    line-height: 0.51rem;
}
.rankListFooter_dark {
  color: rgba(255, 255, 255, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/rankList.vue